'use strict';

angular.module('internal.setup')
    .controller('InternalSetupPublicPortal', ['$scope', '$state', '$stateParams', function ($scope, $state, $stateParams) {
    }])
;